export default __webpack_public_path__ + "static/media/495.4402cdbb.jpg";